export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ23.5f6cf150.mp3";